import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const FreeResourceSection = () => {
  const [sectionRef, sectionVisible] = useScrollAnimation();

  return (
    <section id="free-resource" className="relative py-12 md:py-20 bg-gradient-to-b from-black to-gray-900">
      {/* Background Effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/2 left-1/3 w-96 h-96 bg-[#FFE7AB]/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/3 w-96 h-96 bg-[#5F9BC7]/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <div 
          ref={sectionRef}
          className={`scroll-animate fade-in-bottom ${sectionVisible ? 'visible' : ''} max-w-3xl mx-auto text-center`}
        >
          <div className="bg-gradient-to-br from-white/5 to-white/0 backdrop-blur-sm border border-white/10 rounded-3xl p-8 md:p-10">
            {/* Badge */}
            <div className="flex items-center justify-center gap-2 mb-4">
              <svg className="w-5 h-5 text-[#FFE7AB]" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z" clipRule="evenodd" />
              </svg>
              <span className="text-[#FFE7AB] font-semibold text-xs md:text-sm uppercase tracking-wider">Free Resource</span>
            </div>

            {/* Title */}
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-3">
              Get Your Free Fat Loss Blueprint
            </h2>

            {/* Description */}
            <p className="text-gray-300 text-base md:text-lg mb-1">
              Not ready for 1:1 coaching yet?
            </p>
            <p className="text-gray-400 text-sm md:text-base mb-6 max-w-xl mx-auto">
              The exact framework I use with my clients to achieve sustainable fat loss
            </p>

            {/* CTA Button */}
            <Button
              onClick={() => window.open('https://whop.com/checkout/plan_D6Ulq0Ra5j2ni', '_blank')}
              size="lg"
              className="group bg-gradient-to-r from-[#FFE7AB] to-[#E6D199] hover:from-[#E6D199] hover:to-[#FFE7AB] text-black px-6 md:px-8 py-4 md:py-6 text-base md:text-lg rounded-xl font-semibold shadow-2xl shadow-[#FFE7AB]/30 transition-all duration-300 hover:shadow-[#FFE7AB]/50 hover:scale-105 w-full sm:w-auto"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Download Free Blueprint
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeResourceSection;
